import classnames from 'classnames'
import { useState } from 'react'

import { IconChevronDown, IconHelpCircle, Tooltip } from '@/components'
import { SystemDiagnosticCategoryEnum } from '@/enums'
import { SystemDiagnosticMetric, Warranty } from '@/models'

type TeslaDiagnosticsSection = {
    warranty: Warranty
}

export const TeslaDiagnosticsSection = ({ warranty }: TeslaDiagnosticsSection) => {
    const [openCategories, setOpenCategories] = useState<SystemDiagnosticCategoryEnum[]>([
        warranty.systemDetails?.diagnosticCategories.length
            ? warranty.systemDetails?.diagnosticCategories[0].key
            : SystemDiagnosticCategoryEnum.SYSTEM_PERFORMANCE
    ])

    const handleClick = (value: SystemDiagnosticCategoryEnum) => {
        setOpenCategories(state => state.includes(value)
            ? state.filter(item => item !== value)
            : [...state, value])
    }

    return !!warranty.systemDetails?.diagnosticCategories.length &&
        <div className="border rounded-lg border-separate border-gray-200 bg-white w-full overflow-auto">
            <table className="w-full">
                <tbody>
                    {warranty.systemDetails?.diagnosticCategories.map(item => <>
                        <tr className="bg-orange-50 border-b border-gray-200">
                            <td colSpan={3} className="">
                                <button
                                    onClick={() => handleClick(item.key)}
                                    className="cursor-pointer flex items-center gap-4 text-lg font-semibold w-full py-4 px-6"
                                >
                                    <IconChevronDown
                                        className={classnames(
                                            'stroke-gray-700 transition-all shrink-0',
                                            { 'rotate-180': openCategories.includes(item.key) }
                                        )}
                                    />
                                    {item.title}

                                    {!!item.erroredMetrics.length && <div
                                        className="text-base font-normal text-gray-500 flex items-center gap-2"
                                    >
                                        {SystemDiagnosticMetric.erroredIcon}
                                        Error: ({item.erroredMetrics.length})
                                    </div>}
                                    {!!item.normalMetrics.length && <div
                                        className="text-base font-normal text-gray-500 flex items-center gap-2"
                                    >
                                        {SystemDiagnosticMetric.normalIcon}
                                        Success: ({item.normalMetrics.length})
                                    </div>}
                                </button>
                            </td>
                        </tr>
                        {openCategories.includes(item.key) && item.metrics.map(item =>
                            <tr className="border-b border-gray-200 text-sm text-gray-800">
                                <td className="py-4 px-6 flex items-center gap-1">
                                    {item.title}
                                    {item.description && <Tooltip
                                        content={<div className="max-w-75">
                                            <h4 className="font-bold">{item.title}</h4>
                                            <p>{item.description}</p>
                                        </div>}
                                    >
                                        <IconHelpCircle className="stroke-gray-400" size="sm"/>
                                    </Tooltip>}
                                </td>
                                <td className="py-4 px-6">
                                    {item.valueFormatted ?? '-'}
                                </td>
                                <td className="py-4 px-6">
                                    {item.statusIcon}
                                </td>
                            </tr>)}
                    </>)}
                </tbody>
            </table>
        </div>
}
